import { render, staticRenderFns } from "./AutoLogCa.vue?vue&type=template&id=229b252b&"
import script from "./AutoLogCa.vue?vue&type=script&lang=js&"
export * from "./AutoLogCa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports